/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ position: NonNullable<unknown> }} Endpoint_Role_BackupInputs */

const en_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Backup ${i?.position}`)
};

const zh_hans1_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`备用 ${i?.position}`)
};

const pt_br2_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Reserva ${i?.position}`)
};

const es_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Respaldo ${i?.position}`)
};

const fr_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Secours ${i?.position}`)
};

const de_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ersatz ${i?.position}`)
};

const ru_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Резерв ${i?.position}`)
};

const it_endpoint_role_backup = /** @type {(inputs: Endpoint_Role_BackupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riserva ${i?.position}`)
};

/**
* | output |
* | --- |
* | "Backup {position}" |
*
* @param {Endpoint_Role_BackupInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_role_backup = /** @type {((inputs: Endpoint_Role_BackupInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Role_BackupInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_role_backup(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_role_backup(inputs)
	if (locale === "es") return es_endpoint_role_backup(inputs)
	if (locale === "fr") return fr_endpoint_role_backup(inputs)
	if (locale === "de") return de_endpoint_role_backup(inputs)
	if (locale === "ru") return ru_endpoint_role_backup(inputs)
	if (locale === "it") return it_endpoint_role_backup(inputs)
	return en_endpoint_role_backup(inputs)
});